import React from 'react'
import { type VariantProps } from 'class-variance-authority'
import { cn } from '../../../lib/utils'
import { boxVariants } from '../../../utils/layoutVariants'

export interface BoxProps
  extends
    React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof boxVariants> {
  as?: React.ElementType
}

const Box = React.forwardRef<HTMLDivElement, BoxProps>(
  (
    {
      className,
      display,
      padding,
      margin,
      borderRadius,
      shadow,
      background,
      border,
      as: Component = 'div',
      ...props
    },
    ref
  ) => {
    return (
      <Component
        ref={ref}
        className={cn(
          boxVariants({
            display,
            padding,
            margin,
            borderRadius,
            shadow,
            background,
            border,
          }),
          className
        )}
        {...props}
      />
    )
  }
)
Box.displayName = 'Box'

export { Box }
